import React, { Component } from "react";

import axios from "axios";
import moment from "moment";
import Modal from "./Modal";
import TextField from "./form/TextField";
import DatePicker, { registerLocale } from "react-datepicker";
import nb from "date-fns/locale/nb";
import CheckboxField from "./form/CheckboxField";
import db from "../../api/db";
import CircularProgress from "@material-ui/core/CircularProgress";

registerLocale("nb", nb);

class JubileeListsRow extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      client: this.props.Client,
      persons: 0,
      loading: false,
      showModal: false,
      showStartModal: false,
      sendinglist: false,
      submitmail: this.props.Client.mails.join(),
      //submitmail: "personalia@ntb.no",
      lastupdate: false,
      setSubmit: true,
      startTime: moment()
        .add(1, "d")
        .toDate(),
      fromdate: moment().toDate(),
      todate: moment()
        .add(42, "d")
        .toDate()
    };
  }

  Start = () => this.startClient();
  Stop = () => this.stopClient();
  Send = () => this.SendClient();
  Aggregate = () => this.AgregateClient();

  // Modal actions
  handleEmailChange = e => this.setState({ submitmail: e.target.value });
  handleFromdateChange = date => this.setState({ fromdate: date });
  handleTodateChange = date => this.setState({ todate: date });
  handleShowModal = () => this.setState({ showModal: true });
  handleCloseModal = () => this.setState({ showModal: false });
  handleShowStartModal = () => this.setState({ showStartModal: true });
  handleCloseStartModal = () => this.setState({ showStartModal: false });
  handleStartdateChange = date => this.setState({ startTime: date });
  handleSubmitChange = e => this.setState({ setSubmit: e.target.checked });

  componentDidMount() {
    this._isMounted = true;
    this.getListState();
    this.setAutoReload();
  }

  componentWillUnmount() {
    this._isMounted = false;
    clearInterval(this.interval);
  }

  setAutoReload() {
    this.interval = setInterval(() => this.getListState(), 300000);
  }

  getClient() {
    db.get("client", this.props.Client.id).then(response => {
      if (this._isMounted) {
        this.setState({
          client: response.data
        });
      }
    });
  }

  getListState() {
    this.setState({
      loading: true
    });
    db.query("list", {
      type: "jubilee",
      client: this.state.client.id,
      date: {
        from: `${moment()
          .subtract(14, "d")
          .format("YYYY-MM-DD")} 00:00:00`,
        to: `${moment()
          .add(42, "d")
          .format("YYYY-MM-DD")} 00:00:00`
      },
      pagination: {
        size: 60,
        from: 0
      }
    }).then(response => {
      let persons = 0;
      let lastupdate = false;
      let last = moment().subtract(100, "d");
      for (var i = response.data.hits.length - 1; i >= 0; i--) {
        if (moment() <= moment(response.data.hits[i].date)) {
          persons += response.data.hits[i].persons.length;
        }
        if (
          response.data.hits[i].update &&
          last < moment(response.data.hits[i].update)
        ) {
          last = lastupdate = response.data.hits[i].update;
        }
      }
      if (this._isMounted) {
        this.setState(
          {
            persons: persons,
            lastupdate: lastupdate,
            loading: false
          },
          () => {
            this.getClient();
          }
        );
      }
    });
  }

  AgregateClient() {
    this.setState({ loading: true });
    axios
      .get("/api/operations/agregatejubileelists/" + this.state.client.id)
      .then(response => {
        this.setState({ loading: false });
        this.getListState();
      });
  }

  startClient() {
    this.setState({
      loading: true,
      showStartModal: false
    });

    var startTime = moment(this.state.startTime).unix();

    axios
      .get(
        "/api/operations/startjubileemanual/" +
          this.state.client.id +
          "/" +
          startTime
      )
      .then(response => {
        if (this._isMounted) {
          this.setState(
            {
              client: response.data,
              loading: false
            },
            () => {
              this.getListState();
            }
          );
        }
      });
  }

  SendClient(
    email = this.state.submitmail,
    from = this.state.fromdate,
    to = this.state.todate
  ) {
    this.setState({
      loading: true,
      showModal: false
    });

    axios
      .get("/api/operations/agregatejubileelists/" + this.state.client.id)
      .then(response => {
        axios({
          method: "post",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json"
          },
          url: "/api/operations/SendJubileeDocument",
          data: {
            id: this.state.client.id,
            email: this.state.submitmail.split(),
            from: moment(from).format("YYYY-MM-DD"),
            to: moment(to).format("YYYY-MM-DD"),
            index: true,
            setsubmit: this.state.setSubmit
          }
        })
          .then(response => {
            if (this._isMounted) {
              this.getListState();
              this.setState({
                loading: false
              });
            }
          })
          .catch(err => {
            console.log(err);
            this.setState({
              loading: false
            });
          });
      })
      .catch(err => {
        console.log(err);
        this.setState({
          loading: false
        });
      });
  }

  stopClient() {
    this.setState({ loading: true });

    db.patch("client", {
      id: this.state.client.id,
      next_jubilee_batch: ""
    }).then(response => {
      this.setState({
        client: response.data,
        loading: false
      });
    });
  }

  sendAble() {
    if (this.state.loading) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    const client = this.state.client;
    const NextBatch = client.next_jubilee_batch;

    return (
      <React.Fragment>
        <tr className="spacer"></tr>
        <tr className={this.props.Row}>
          <td>{client.name}</td>
          <td>
            {client.jubilee_submitted
              ? `${moment(client.jubilee_submitted).format(
                  "DD.MM.YY"
                )} - ${moment(client.jubilee_submitted)
                  .add(42, "d")
                  .format("DD.MM.YY")}`
              : ""}
          </td>
          <td>
            {this.state.loading ? (
              <CircularProgress size={20} />
            ) : (
              this.state.persons
            )}
          </td>
          <td>
            {client.next_jubilee_batch
              ? `${moment.unix(NextBatch).format("HH:mm D.MMM")}`
              : "Inaktiv"}
          </td>
          <td>
            {client.jubilee_lastupdate
              ? moment(client.jubilee_lastupdate).format("HH:mm D.MMM")
              : this.state.lastupdate
              ? moment(this.state.lastupdate).format("HH:mm D.MMM")
              : "-"}
          </td>
          <td>
            {client.next_jubilee_batch ? (
              <button
                className="button small red"
                onClick={this.Stop}
                disabled={this.state.loading}
              >
                Stopp
              </button>
            ) : (
              <button
                className="button small yellow"
                onClick={this.handleShowStartModal}
                disabled={this.state.loading}
              >
                Start
              </button>
            )}
          </td>
          <td>
            <button
              className="button small"
              onClick={this.handleShowModal}
              disabled={this.sendAble()}
            >
              Send
            </button>
          </td>
        </tr>

        {this.state.showModal ? (
          <Modal onClose={this.handleCloseModal} closelabel="Send liste">
            <div>
              <div className="heading">Send Jubilantoversikt</div>
              <div className="grid-x">
                <div className="cell small-6">
                  <label>Fra</label>
                  <DatePicker
                    selected={this.state.fromdate}
                    onChange={this.handleFromdateChange}
                    onSelect={this.handleFromdateChange}
                    minDate={moment().toDate()}
                    maxDate={this.state.todate}
                    dateFormat="dd.MMMM yyyy"
                    locale="nb"
                  />
                </div>
                <div className="cell small-6">
                  <label>Til</label>
                  <DatePicker
                    selected={this.state.todate}
                    onChange={this.handleTodateChange}
                    onSelect={this.handleTodateChange}
                    minDate={this.state.fromdate}
                    maxDate={this.state.todate}
                    dateFormat="dd.MMMM yyyy"
                    locale="nb"
                  />
                </div>
              </div>
              <TextField
                className="white-input"
                name="email"
                value={this.state.submitmail}
                label="Epost"
                onChange={this.handleEmailChange}
              />
              <CheckboxField
                name="setsubmit"
                value={this.state.setSubmit}
                label="Registrer som sendt til kunde"
                onChange={this.handleSubmitChange}
              />
            </div>
            <button className="button" onClick={this.Send}>
              Send Liste
            </button>
            <button className="button abort" onClick={this.handleCloseModal}>
              Avbryt
            </button>
          </Modal>
        ) : null}

        {this.state.showStartModal ? (
          <Modal onClose={this.handleCloseStartModal} closelabel="Sett start">
            <div>
              <div className="heading">Sett automatisk jubilantgenerering</div>
              <div className="grid-x">
                <div className="cell small-12">
                  <label>Startdato</label>
                  <DatePicker
                    selected={this.state.startTime}
                    onChange={this.handleStartdateChange}
                    onSelect={this.handleStartdateChange}
                    showTimeSelect
                    locale="nb"
                    timeFormat="HH:mm"
                    timeIntervals={60}
                    dateFormat="dd.MMMM yyyy HH:mm"
                    timeCaption="Tid"
                  />
                </div>
              </div>
            </div>
            <button className="button" onClick={this.Start}>
              Start
            </button>
            <button
              className="button abort"
              onClick={this.handleCloseStartModal}
            >
              Avbryt
            </button>
          </Modal>
        ) : null}
      </React.Fragment>
    );
  }
}
/*
 * Disabled button
 * <td><button className="button small" onClick={ this.Aggregate } disabled={this.state.loading}>Aggreger</button></td>
 */
export default JubileeListsRow;
